module.exports = __webpack_public_path__ + "static/media/4.6cb5f8a5.png";